/**
 * Globo Indonesia Translation Fix
 * 
 * Daftar mapping label yang perlu di-fix dari Globo translation.
 * Format: 'data-fvalue': 'Label yang benar'
 * 
 * Cara pakai:
 *   - Tambahkan entry baru ke LABEL_FIXES di bawah
 *   - Key = nilai data-fvalue dari button Globo
 *   - Value = label yang ingin ditampilkan
 */
(function () {
    var LABEL_FIXES = {
        // ─── Size Filter (Ukuran) ───────────────────────────
        // Globo menganggap 0, 00, 000 sama, jadi semua jadi "00"
        '000': '000',
        '00': '00',
        '0': '0',

        // ─── Tambahkan mapping lain di sini ─────────────────
        // Contoh:
        // 'ONE SIZE': 'SATU UKURAN',
        // 'XS': 'XS',
    };

    function fixFilterLabels() {
        var buttons = document.querySelectorAll(
            '.gf-option-box button[role="checkbox"][data-fvalue], .gf-option-box a[data-fvalue]'
        );

        buttons.forEach(function (btn) {
            var fvalue = btn.getAttribute('data-fvalue');
            if (!fvalue || !(fvalue in LABEL_FIXES)) return;

            var correctLabel = LABEL_FIXES[fvalue];
            var label = btn.querySelector('.gf-label');

            if (label && label.textContent.trim() !== correctLabel) {
                label.textContent = correctLabel;
            }

            if (btn.getAttribute('title') !== correctLabel) {
                btn.setAttribute('title', correctLabel);
            }
        });
    }

    // Run on initial load (after Globo has rendered)
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            setTimeout(fixFilterLabels, 1500);
        });
    } else {
        setTimeout(fixFilterLabels, 1500);
    }

    // Run every time Globo re-renders filters
    window.addEventListener('globoFilterRenderCompleted', function () {
        setTimeout(fixFilterLabels, 300);
    });
})();
